import { useEffect, useState } from "react";
import { fetchWeatherData, type WeatherData } from "@/services/weatherService";
import { getWeatherIcon } from "@/utils/weatherIcons";
import { useLanguage } from "@/contexts/LanguageContext";
import { getWeatherDescription, UI_TRANSLATIONS } from "@/lib/i18n";

interface WeatherWidgetProps {
  location: string;
  lat: number;
  lon: number;
  apiKey?: string;
}

export const WeatherWidget = ({ location, lat, lon, apiKey }: WeatherWidgetProps) => {
  const { language } = useLanguage();
  const translations = UI_TRANSLATIONS[language];
  const [weather, setWeather] = useState<WeatherData>({
    location: location,
    description: "",
    temp: 0,
    weatherCode: 800
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWeather = async () => {
      try {
        const data = await fetchWeatherData(location, lat, lon, apiKey, language);
        setWeather(data);
      } catch (error) {
        // Fallback to mock data if API fails
        setWeather({
          location: location,
          description: "",
          temp: 18,
          weatherCode: 801
        });
      } finally {
        setLoading(false);
      }
    };

    loadWeather();
  }, [lat, lon, location, apiKey, language]);

  const WeatherIcon = getWeatherIcon(weather.weatherCode);
  const description = getWeatherDescription(
    weather.weatherCode,
    language,
    weather.description,
  );

  return (
    <div className="weather-widget">
      <div className="weather-left">
        <div className="weather-location">{weather.location}</div>
        <div className="weather-desc">
          {loading ? translations.loading : description}
        </div>
      </div>
      <div className="weather-right">
        <WeatherIcon className="weather-icon text-white" />
        <div className="weather-temp">{weather.temp}°</div>
      </div>
    </div>
  );
};
